module.exports = __webpack_public_path__ + "img/13-l.d3747e96.png";